<template>
  <div>
    <div class="content_bg">
      <div :style="borderStyle"></div>
      <div class="content">
        <div class="content_core" @click="onClick">
          <div class="app_title_group">
            <div>
              <img class="icon_image" :src="record.icon" />
            </div>
            <div class="title_group" :style="colorStyle">
              <div class="title">{{ record.name }}</div>
              <div class="title_right">[파트너쉽]</div>
            </div>
          </div>

          <div class="sub_title" :style="colorStyle">
            {{ record.sub_text }}
          </div>

          <div class="desc" v-html="formattedText3"></div>
        </div>

        <div class="content_download">
          <div style="font-size: 20px; font-weight: 700">
            {{ record.performance_number_label }}
          </div>
          <span class="download_count">{{ record.performance_number }}</span>
          <div style="font-size: 19px; color: #666666; font-weight: 500">
            {{ record.performance_desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  props: ["record", "id", "image", "text1", "text2", "text3", "link"],
  data() {
    return {
      color: "#0190FF",
    };
  },
  mounted() {
    this.color = this.record.color;
  },
  computed: {
    formattedText3: function () {
      return this.text3.replace(/\n/g, "<br>");
    },
    borderStyle() {
      return {
        backgroundColor: this.color,
        opacity: 0.04,
        position: "absolute",
        width: "100%",
        height: "100%",
      };
    },
    colorStyle() {
      return {
        color: this.color,
      };
    },
  },
  methods: {
    onClick() {
      this.$router.push('/portfolio/detail/' + this.record.id);
    },
  },
};
</script>
    
  <style scoped>
.content_bg {
  height: 400px;
  justify-content: center;
  background-color: #ffffff;
}

.content {
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  display: inline-block;
}

.app_title_group {
  display:flex;
}

.title_group {
  display: flex;
  align-items: baseline;
}

.icon_image {
  width: 100px;
  height: 100px;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
}

.title {
  margin-top: 10px;
  font-size: 52px;
  font-weight: 700;
  margin-left: 26px;
}

.title_right {
  font-size: 20px;
  font-weight: 700;
  margin-left: 10px;
}

.sub_title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 30px;
}

.desc {
  font-size: 17px;
  font-weight: 300;
  margin-top: 10px;
}

.content_core {
  margin-left: 50px;
  margin-top: 100px;
  text-align: left;
  width: fit-content;
  position: absolute;
  cursor:pointer;
}

.content_download {
  position: absolute;
  width: 400px;
  margin-left: 700px;
  margin-top: 130px;
}

.download_count {
  font-size: 50px;
  font-weight: 700;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    height: fit-content;
    background-color: #ffffff;
  }

  .content {
    width: 100vw;
    height: fit-content;
    max-width: 1140px;
    display: block;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .content_core {
    display: inline-block;
    height: fit-content;
    margin-left: 0px;
    margin-top: 0px;
    text-align: center;
    width: fit-content;
    position: relative;
  }

  .content_download {
    display: block;
    width: 100%;
    margin-left: 0px;
    margin-top: 50px;
    position: relative;
  }

  .app_title_group {
    display:inline-block;
  }
  .title_group {
    display: inline-block;
    text-align: center;
  }

  .icon_image {
    width: 80px;
    height: 80px;
    border-radius: 16px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  }

  .title {
    margin-top: 30px;
    font-size: 32px;
    font-weight: 700;
    margin-left: 0px;
  }

  .title_right {
    font-size: 17px;
    font-weight: 700;
    margin-left: 0px;
  }

  .sub_title {
    font-size: 17px;
    font-weight: 700;
    margin-top: 10px;
  }

  .desc {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 17px;
    font-weight: 300;
    margin-top: 10px;
  }

  .download_count {
    font-size: 30px;
    font-weight: 700;
  }
}

</style>